import { IndexPageBase } from '@flipdish/api-client-typescript';
import { ExpansionPanelDetails, FormControl, FormHelperText, makeStyles } from '@material-ui/core';
import { Field, FieldProps, FormikProps, withFormik } from 'formik';
import React, { ChangeEvent, memo } from 'react';
import { Translate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { formikValidate } from '../../../helpers/validation';
import { createLoadingSelector } from '../../../selectors/loading.selector';
import Button from '../../../ui/Button/Button';
import TextField from '../../../ui/TextField/TextField';
import { SET_WEBSITE_SETTINGS, setWebsiteSettings } from '../actions';

const savingSelector = createLoadingSelector([SET_WEBSITE_SETTINGS]);

const useStyles = makeStyles({
  content: {
    alignItems: 'center',
    flexDirection: 'column',
  },
  helperText: {
    textAlign: 'center',
  },
});

type FormValues = IndexPageBase;

type OuterProps = {
  settings: IndexPageBase;
};

type InnerProps = FormikProps<FormValues> &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

type Props = OuterProps & InnerProps;

const validate = (value: string) => {
  return formikValidate.required(value) || formikValidate.email(value);
};

const mapStateToProps = (state: AppState) => {
  return {
    saving: savingSelector(state),
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch) => ({
  setSettings: (settings: IndexPageBase) => dispatch(setWebsiteSettings(settings)),
});

export default compose<InnerProps, OuterProps>(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withFormik<Props, FormValues>({
    displayName: 'EditWebsiteSettingsContactFormPanelForm',
    enableReinitialize: true,
    mapPropsToValues(props) {
      const { settings } = props;

      return { ...settings };
    },
    handleSubmit(values, formikBag) {
      formikBag.props.setSettings(values);
    },
  })
)(
  memo(function EditWebsiteSettingsContactFormPanelForm(props: Props) {
    const classes = useStyles();
    const { submitForm, dirty, saving } = props;

    return (
      <ExpansionPanelDetails className={classes.content}>
        <Field name="ContactFormEmail" validate={validate}>
          {(fProps: FieldProps) => {
            const { field, form } = fProps;
            const error = form.errors[field.name];

            return (
              <FormControl fullWidth error={!!error}>
                <Translate id="Contact_form_copy" />
                <TextField
                  fdKey="contact_form_email"
                  value={field.value || ''}
                  label={<Translate id="Email" />}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    form.setFieldValue(field.name, e.target.value);
                  }}
                />
                {error ? <FormHelperText>{error}</FormHelperText> : null}
              </FormControl>
            );
          }}
        </Field>

        <FormHelperText className={classes.helperText}>
          <Translate id="Contact_form_helper_text" />
        </FormHelperText>

        <Button fdKey="save_contact_form" onClick={submitForm} disabled={!dirty || saving}>
          <Translate id="Save" />
        </Button>
      </ExpansionPanelDetails>
    );
  })
);
